import { Component, Prop, Inject, Watch } from "vue-property-decorator";
import MergeHooks from "@/decorators/mergeHooks";

import { downloadFile } from "@/utils/index";
import { exportDmp } from "@/api/api"
import dayjs from "dayjs";
import R from "ramda";
import {
  IothubPropertyServiceProxy,
  WorkStationIotServiceProxy,
  GatewayServiceProxy,
  IotServiceProxy,
} from "@/service-proxies/app-v2/workStation.service-proxies";
import {
  IotTypes,
  TabTypes,
  addressTypes,
  fetchFnsMap,
  submitFnsMap,
  deleteFnsMap,
  ACLS,
} from "@/components/RenderUtils/utils/constants";
import renderUtils from "@/components/RenderUtils";
import getStyles from "@/components/RenderUtils/utils/style";
import getLang from "@/components/RenderUtils/utils/lang";
import iotInputModal from "./iotInputModal";
import { tranformOptionsShape } from "@/components/RenderUtils/utils/index";
import { getUserInfo, getToken } from "@/utils/auth";
import { exportGateway } from "@/api/api";
import {
  IotAppServiceProxy,
  ProductBatchServiceProxy,
  GatewayServiceProxy as IotGatewayServiceProxy,
  IotAppSettingServiceProxy,
  IotAppPropertyServiceProxy
} from '@/service-proxies/app-v2/iot-console.service-proxies'
import { dataTypes } from '@/views/console/gateway-list/components/data'
import { switchAll } from 'rxjs/operators'
import '../style/associatedlot.less'

const service = new IothubPropertyServiceProxy();
const iotService = new WorkStationIotServiceProxy();
const gatewayService = new GatewayServiceProxy();
const isp = new IotServiceProxy();

const iasp = new IotAppServiceProxy()
const batchServ = new ProductBatchServiceProxy()
const iotGatewayService = new IotGatewayServiceProxy()
const iassp = new IotAppSettingServiceProxy()
const iapsp = new IotAppPropertyServiceProxy()

enum Colors {
  "#5D7092",
  "#E8684A",
  "#F6BD16",
  "#5B8FF9",
  "#269A99",
}

enum Status {
  "未知",
  "故障",
  "应用异常",
  "工作中",
  "通道异常",
}

@Component({
  iotInputModal,
})
@MergeHooks
export default class AssociatedIot extends renderUtils {
  @Inject() readonly refresh!: any;
  @Prop() workstationId!: any;
  @Prop({ default: () => {} }) readonly sourceData: any;

  exportLoading = false
  importLoading = false
  selectAppId: any = null;
  appProps = [];
  showLiveModal = false;
  showModal = false;
  type = IotTypes.AppCreate;
  editData = {};
  configOptions = [];
  activeTab = TabTypes.Left;
  ws: any = null;
  liveData = [];
  gatewayStatus = null;
  appStatus = {};
  gatewayAppStatus = 0;
  loading = false;
  inputModal = false;
  confirmLoading = false;


  subLoading = false
  appList = []
  appSettingLoading = false
  appSettingList = []
  appPropertyLoading = false
  appPropertyList = []
  settingModalVisible = false
  settingForm = {}
  settingFormItems = []

  get iotVersion() { // 1:新版本，0：旧版本
    return this.sourceData && this.sourceData.iotVersion ? 1 : 0
  }

  get lang() {
    return getLang(this);
  }

  get hidden() {
    if (this.type !== IotTypes.PropCreate && this.type !== IotTypes.PropModify)
      return [];
    const isLeft = R.equals(TabTypes.Left, this.activeTab);
    const keys = Object.keys(this.propSchema);
    return isLeft
      ? R.without(["name", "extendField.unit"])(keys)
      : ["name", "extendField.unit", "baseField.access"];
  }

  get selectApp() {
    if (!this.selectAppId) return {};
    const find = (this.sourceData.iotApps || []).find(
      (item) => item.id == this.selectAppId
    );
    return find || {};
  }

  get columns() {
    return [
      {
        title: this.lang.prop_name,
        dataIndex: "name",
      },
      {
        title: this.lang.address,
        dataIndex: "address",
      },
      {
        title: this.lang.data_type,
        dataIndex: "dataType",
      },
    ];
  }

  get liveColumns() {
    return [
      {
        title: this.lang.prop_name,
        dataIndex: "propertyName",
        width: 150,
      },
      {
        title: this.lang.data,
        dataIndex: "propertyValue",
        customRender: (text) => {
          return (
            <ellipsis length={50} tooltip>
              {text}
            </ellipsis>
          );
        },
      },
      {
        title: this.lang.update_time,
        dataIndex: "reportTime",
        width: 240,
        customRender: (reportTime) =>
          !reportTime || reportTime === "-"
            ? "-"
            : dayjs(reportTime).format("YYYY-MM-DD HH:mm:ss"),
      },
    ];
  }

  get newAppColumns() {
    return [
      {
        title: this.$t('actions'),
        dataIndex: 'operation',
        width: 160,
        ellipsis: true,
        customRender: (text, record, index) => {
          return (
            <div>
              <a onClick={()=>this.openLiveDataModel(record, 'new')}>{this.lang.live_data}</a>
              <a-divider type="vertical"/>
              <a onClick={() => this.openAppSettingModal(record)}>{this.lang.view_setting}</a>
              <a-divider type="vertical"/>
              <a onClick={()=>this.openAppPropertyModal(record)}>{this.lang.view_parameters}</a>
            </div>
          )
        }
      },
      {
        title: 'APP ID',
        dataIndex: 'code',
        width: 100,
        ellipsis: true
      },
      {
        title: this.lang.app_name,
        dataIndex: 'name',
        width: 130,
        ellipsis: true
      },
      {
        title: this.lang.isOnline,
        dataIndex: 'isOnline',
        customRender: (text, _record, index) => {
          return (
            <div>
              <a-tag color={text ? 'green' : 'volcano'}>
                {text ? this.$t('online') : this.$t('offline')}
              </a-tag>
            </div>
          )
        },
        width: 100,
        ellipsis: true
      }
    ]
  }

  get appPropertyColumns() {
    const isTakeEffected = [this.lang.isTakeEffected_not_submit, this.lang.isTakeEffected_pending, this.lang.isTakeEffected_true, this.lang.isTakeEffected_false]
    return [
      {
        title: this.$t('page_workstation_code'),
        dataIndex: 'code',
        width: 80,
        ellipsis: true
      },
      {
        title: this.$t('page_workstation_name'),
        dataIndex: 'name',
        width: 120,
        ellipsis: true
      },
      {
        title: this.lang.ioAddress,
        dataIndex: 'ioAddress',
        width: 150,
        ellipsis: true
      },
      {
        title: this.lang.data_type,
        dataIndex: 'type',
        width: 100,
        ellipsis: true,
        customRender: (text) => text ? dataTypes[text].toLowerCase() : ''
      },
      {
        title: this.lang.default_value1,
        dataIndex: 'defaultValue',
        width: 120,
        ellipsis: true
      },{
        title: this.lang.isTakeEffected,
        dataIndex: 'isTakeEffected',
        width: 100,
        ellipsis: true,
        customRender: (text) => isTakeEffected[text]
      },
      {
        title: this.lang.factor1,
        dataIndex: 'factor',
        width: 100,
        ellipsis: true
      },
      {
        title: this.$t('page_business_data_description'),
        dataIndex: 'description',
        width: 150,
        ellipsis: true
      }
    ]
  }

  get configSchema() {
    // console.log("asasas", this.configOptions);
    // const changeFn = (value, form) => {
    //   return R.pipe(
    //     R.propEq("name"),
    //     R.find(R.__, this.configOptions),
    //     R.pick(["value"]),
    //     form.setFieldsValue
    //   )(value);
    // };
    // const options = tranformOptionsShape("name", "name")(this.configOptions);
    // const defaultName = R.path(["0", "name"])(this.configOptions);
    // const defaultVal = R.path(["0", "value"])(this.configOptions);
    const options = this.configOptions.reduce((total, item) => {
      total[item.name] = {
        label: item.name,
        type: "input",
        defaultValue: item.value,
        rules: [
          {
            required: true,
            message: this.lang.value_required,
          },
        ],
      };
      return total;
    }, {});
    return options;

    // return {
    //   name: {
    //     label: this.lang.name,
    //     type: "select",
    //     options: options,
    //     defaultValue: defaultName,
    //     on: {
    //       change: changeFn,
    //     },
    //     rules: [
    //       {
    //         required: true,
    //         message: this.lang.name_required,
    //       },
    //     ],
    //   },
    //   value: {
    //     label: this.lang.value,
    //     type: "input",
    //     defaultValue: defaultVal,
    //     rules: [
    //       {
    //         required: true,
    //         message: this.lang.value_required,
    //       },
    //     ],
    //   },
    // };
  }

  get appSchema() {
    return {
      name: {
        label: this.lang.app_describe,
        type: "input",
        rules: [
          {
            required: true,
            message: this.lang.app_describe_required,
          },
        ],
      },
      gatewayTypeName: {
        label: this.lang.app_type,
        type: "Select",
        options: tranformOptionsShape(
          "typeName",
          "typeName"
        )(this.configOptions),
        rules: [
          {
            required: true,
            message: this.lang.app_type_required,
          },
        ],
      },
    };
  }

  get propSchema() {
    const isCreate = R.equals(IotTypes.PropCreate, this.type);
    const showRest = R.pipe(R.path(["baseField", "array"]), R.equals(true));

    let schema = {
      name: {
        label: this.lang.name,
        type: "input",
        placeholder: this.lang.name,
        props: {
          disabled: isCreate ? false : true,
        },
        rules: [
          {
            required: true,
            message: this.lang.name_required,
          },
        ],
      },
      "extendField.unit": {
        label: this.lang.unit,
        type: "input",
        placeholder: this.lang.unit,
        props: {
          disabled: isCreate ? false : true,
        },
      },
      "baseField.ioaddress": {
        label: this.lang.prop_address,
        type: "select",
        placeholder: this.lang.prop_address,
        options: tranformOptionsShape("name", "name")(this.configOptions),
        on: {
          change: (value, form, options) => {
            const find = options.find((opt) => opt.value == value);
            if (!find) return;
            const dataType = find.rest.returnType;
            if (!addressTypes.includes(dataType)) return;
            form.setFieldsValue({
              "baseField.dataType": dataType,
            });
          },
        },
      },
      "baseField.props": {
        type: "input",
        label: this.lang.param,
        placeholder: this.lang.param,
        props: {
          placeholder: this.lang.param_placeholder,
        },
        // rules: [
        //   {
        //     pattern: /^([\w.]*,)*[\w.]*$/,
        //     message: this.lang.param_tips,
        //   },
        // ],
      },
      "baseField.access": {
        label: this.lang.access,
        placeholder: this.lang.access,
        type: "radio",
        options: [
          {
            label: this.lang.readwrite,
            value: 2,
          },
          {
            label: this.lang.readonly,
            value: 1,
          },
        ],
        customRender: (code) =>
          code == 1 ? this.lang.readonly : this.lang.readwrite,
      },
      "baseField.dataType": {
        label: this.lang.data_type,
        type: "select",
        placeholder: this.lang.data_type,
        options: R.map(
          R.converge(R.merge, [R.objOf("label"), R.objOf("value")])
        )(addressTypes),
        rules: [
          {
            validator(rule, value, cb) {
              if (value === "any") {
                cb(this.$t("datatype_any_error"));
              }
              cb();
            },
          },
        ],
      },
      "baseField.array": {
        label: this.lang.is_array,
        type: "radio",
        options: [
          {
            label: this.lang.no,
            value: false,
          },
          {
            label: this.lang.yes,
            value: true,
          },
        ],
      },
    };

    const rest = {
      "baseField.value": {
        label: this.lang.default_value,
        placeholder: this.lang.default_value,
        type: R.pipe(
          R.path(["baseField", "dataType"]),
          R.cond([
            [R.equals("datetime"), R.always("datePicker")],
            [R.equals("bit"), R.always("radio")],
            [R.T, R.always("input")],
          ])
        ),
        options: [
          { label: "True", value: 1 },
          { label: "False", value: 0 },
        ],
        without: showRest,
      },
      "baseField.factor": {
        label: this.lang.factor,
        placeholder: this.lang.factor,
        type: "input",
        without: showRest,
      },
      "baseField.maxValue": {
        label: this.lang.max,
        placeholder: this.lang.max,
        type: "input",
        without: showRest,
      },
      "baseField.minValue": {
        label: this.lang.min,
        placeholder: this.lang.min,
        type: "input",
        without: showRest,
      },
      "baseField.precision": {
        label: this.lang.precision,
        placeholder: this.lang.precision,
        type: "input",
        without: showRest,
      },
      "baseField.upperWarn": {
        label: this.lang.upper_warn,
        placeholder: this.lang.upper_warn,
        type: "input",
        without: showRest,
      },
      "baseField.lowerWarn": {
        label: this.lang.lower_warn,
        placeholder: this.lang.lower_warn,
        type: "input",
        without: showRest,
      },
    };

    return { ...schema, ...rest };
  }

  created() {
    this.initData();
  }

  @Watch("sourceData", { deep: true })
  reset() {
    this.initData();
    this.initStatus();
  }

  resetStatus() {
    this.initStatus();
  }

  // 获取网关app表格数据
  initData() {
    if (this.iotVersion === 1) { // 新版本
      this.getAppList()
    } else {
      const isNotNil = R.complement(R.isNil)
      R.pipe(
        R.path(['iotApps', 0, 'id']),
        R.when(isNotNil, this.chooseApp)
      )(this.sourceData)
    }
  }

  mounted() {
    this.initStatus();
  }

  // 获取网关在线状态
  async initStatus() {
    const { iotId } = this.sourceData;
    if (this.iotVersion === 1) { // 新版本
      const { isOnline } = await iotGatewayService.getGatewayById(iotId)
      this.$set(this, 'gatewayStatus', isOnline)
      this.getAppList()
    } else { // 旧版本
      const { gatewayStatus, apps } = await gatewayService.getGatewayStatus(
        iotId
      )
      this.$set(this, 'gatewayStatus', gatewayStatus)
      this.appStatus = apps.reduce(
        (dict, app) => ((dict[app.id] = app.status), dict),
        {}
      )
    }
  }

  beforeDestroy() {
    this.disConnectWs();
  }

  async importDmp(e) {
    try {
      this.importLoading = true
      const file = e.file;
      const data = {
        data: file,
        fileName: file.name,
      };


      await isp.importDmpFile(data, this.sourceData.iotId);
      this.refresh.associatedIots();
      this.$message.success(this.$t("page_workstation_maintain_inport_success"));
    } catch (error) {

    } finally {
      this.importLoading = false
    }

  }

  async exportDmp(e) {
    try {
      this.exportLoading = true
      const res = await exportDmp(this.sourceData.iotId);
      downloadFile(res, "dmp.json");
    } catch (error) {
      if (error.response.data.msg && error.response.data.msg.length < 100) {
        this.$message.error(this.$t(error.response.data.msg))
      }else {
        this.$message.error(this.$t("export_error"));
      }
    } finally {
      this.exportLoading = false
    }
  }

  render() {
    const { iotApps = [], iotCode, iotId } = this.sourceData;
    const appLength = R.prop("length", iotApps);
    const popProps = {
      slot: (
        <a-button
          type="link"
          onClick={this.cancelRealteFunction}
          v-acl={ACLS.CANCEL_RELATE}
        >
          {this.lang.cancel_realte}
        </a-button>
      ),
      title: this.lang.sure_cancel_related,
    };
    const openFn = this.getOpenConfigModalFunction(IotTypes.IotConfig);

    return (
      <div style={getStyles("margBtm30")}>
        <div style={getStyles("header")}>
          <div style={getStyles("flex")}>
            <span>{`${this.lang.iot_no}:${iotCode}`}</span>
            {this.gatewayStatus === null ? null : (
              <div style={getStyles("flex")}>
                <a-badge
                  color={this.gatewayStatus ? Colors[3] : Colors[1]}
                  text={
                    this.gatewayStatus ? this.$t("online") : this.$t("offline")
                  }
                  style={getStyles("margLt5")}
                />
                <a-icon
                  onClick={this.resetStatus}
                  type="reload"
                  style={getStyles("margLt5", "pointer", "statusIcon")}
                />
              </div>
            )}
          </div>
          <div>
            {this.iotVersion === 0 &&
            (
              <span>
              <a-button
                type="link"
                onClick={this.exportDmp}
                loading={this.exportLoading}
                v-acl={ACLS.EXPORT_DMP}
              >
              {this.lang.export_dmp}
              </a-button>
              <a-upload
                style="display:inline-block"
                name="file"
                accept=".json"
                customRequest={this.importDmp}
                fileList={[]}
                v-acl={ACLS.IMPORT_DMP}
              >
              <a-button
                type="link"
                loading={this.importLoading}
              >
              {this.lang.import_dmp}
              </a-button>
              </a-upload>
              <a-button
                type="link"
                onClick={() => openFn(iotId)}
                v-acl={ACLS.CONFIG_IOT}
              >
              {this.lang.config}
              </a-button>
              </span>
            )
            }
            {this.renderPopconfirmWrapper(popProps)}
          </div>
        </div>
        {this.iotVersion === 0 ? (<div>
          {this.renderApps(iotApps)}
          {appLength ? this.renderAppbody() : null}
          {this.renderModal()}
        </div>) : (<div>
          {this.renderNewPorps()}
          {this.renderAppProperty()}
          {this.renderAppSettingModal()}
        </div>)
        }
        {/*实时数据*/}
        {this.renderLiveDataModel()}
      </div>
    );
  }

  // 查看设置弹出框
  renderAppSettingModal() {
    let close = ()=> this.settingModalVisible = false
    let form = ()=> (<a-form-model label-col={{ span: 6 }} wrapper-col={{ span: 16 }}>
      {this.settingFormItems.map((item, index) => {
        let formItem
        {switch(item.type){
          case 'input' :
            formItem = (<a-input placeholder={this.$t('page_material_warehousing_p_input')} value={this.settingForm[item.key]}/>)
            break
          case 'numberInput' :
            formItem = (<a-input-number placeholder={this.$t('page_material_warehousing_p_input')} value={this.settingForm[item.key]}
                                    style="width:100%"/>)
            break
          case 'timePicker' :
            formItem = (<a-date-picker style="width:100%" format="YYYY-MM-DD HH:mm:ss" value={this.settingForm[item.key]}/>)
            break
          default:
        }}
        return (
          <a-form-model-item label={item.label} key={index}>
            {formItem}
          </a-form-model-item>
        )
      })}
    </a-form-model>)

    return (
      <a-modal
        onCancel={close}
        title={this.lang.view_setting}
        visible={this.settingModalVisible}
        destroyOnClose={true}
        maskClosable={false}
        width={800}
        footer={null}
      >
        {form()}
      </a-modal>
    )

  }

  renderApps(apps) {
    const { iotId } = this.sourceData;
    const openFn = this.getOpenConfigModalFunction(IotTypes.AppCreate);

    const addApp = (
      <a-button
        icon="plus"
        onClick={() => openFn(iotId, "")}
        v-acl={ACLS.CREATE_APP}
      >
        {this.lang.create_app}
      </a-button>
    );

    const renderAppTab = ({ name, id }) => {
      return (
        <a-tab-pane key={id}>
          <a-tooltip slot="tab">
            <div slot="title">
              {name}:{Status[this.appStatus[id]]}
            </div>
            <div style={getStyles("flex")}>
              <span>{name.substring(0, 6)}</span>
              <a-badge
                style={getStyles("margLt8")}
                color={Colors[this.appStatus[id]]}
              />
            </div>
          </a-tooltip>
        </a-tab-pane>
      );
    };

    return (
      <div>
        <a-tabs
          onChange={this.chooseApp}
          tabBarExtraContent={addApp}
          animated={false}
          class="app-tabs"
        >
          {R.map(renderAppTab, apps)}
        </a-tabs>
      </div>
    );
  }

  renderAppbody() {
    const popProps = {
      slot: (
        <a-button
          type="link"
          style="color: red"
          onClick={() => this.getDeleteFunction("app")(this.selectAppId)}
          v-acl={ACLS.DELETE_APP}
        >
          {this.lang.delete_app}
        </a-button>
      ),
      title: this.lang.sure_delete_app,
    };
    const appOpenFn = this.getOpenConfigModalFunction(IotTypes.AppConfig);
    const propOpenFn = this.getOpenConfigModalFunction(IotTypes.PropCreate);

    return (
      <div style={getStyles("appWrapper")}>
        <div style={getStyles("header")}>
          <a-button-group>
            <a-button
              type="link"
              onClick={() => propOpenFn(this.selectAppId)}
              v-acl={ACLS.CREATE_PROP}
            >
              {this.lang.add_prop}
            </a-button>
            <a-button
              type="link"
              onClick={() => appOpenFn(this.selectAppId)}
              v-acl={ACLS.CONFIG_APP}
            >
              {this.lang.apply_setting}
            </a-button>
            <a-button
              type="link"
              onClick={this.outPutModel}
              v-acl={ACLS.EXPORT_MODEL}
            >
              {this.$t("page_product_export")}
            </a-button>
            <a-button
              type="link"
              onClick={this.inPutModel}
              v-acl={ACLS.INPOERT_MODEL}
            >
              {this.$t("page_business_data_import_product")}
            </a-button>
            {this.renderPopconfirmWrapper(popProps)}
          </a-button-group>
          <a-button-group>
            <a-popover title="应用信息" trigger="click">
              <div slot="content">
                <p>应用驱动: {this.selectApp.gatewayAppTypeName}</p>
                <p>版本号: {this.selectApp.version}</p>
              </div>
              <a-button type="link">{this.lang.app_data}</a-button>
            </a-popover>
            <a-button
              type="link"
              onClick={()=>this.openLiveDataModel(null, 'old')}
              v-acl={ACLS.LIVE_DATA}
            >
              {this.lang.live_data}
            </a-button>
          </a-button-group>
        </div>
        <iotInputModal
          visible={this.inputModal}
          id={this.selectAppId}
          onClose={this.closeInputModel}
        ></iotInputModal>
        {this.renderProps()}
      </div>
    );
  }

  // 物模型导入导出
  outPutModel() {
    exportGateway({ gatewayAppId: this.selectAppId }).then((res) => {
      const data = res as any;
      let blob = new Blob([data]);
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, `IOT编号:${this.selectAppId}.txt`);
      } else {
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = `IOT编号:${this.selectAppId}.txt`; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }
    });
  }

  inPutModel() {
    this.inputModal = true;
  }

  closeInputModel() {
    this.chooseApp(this.selectAppId);
    this.inputModal = false;
  }

  // 渲染老表格
  renderProps() {
    const deleteFn = R.pipe(
      R.prop("name"),
      R.curryN(2, this.getDeleteFunction("prop"))(this.selectAppId)
    );
    const openFn = this.getOpenConfigModalFunction(IotTypes.PropModify);

    const props = {
      columns: this.columns,
      dataSource: this.appProps,
      actions: {
        edit: {
          acl: ACLS.EDIT_PROP,
          action: R.curryN(3, openFn)(this.selectAppId, R.__, true),
        },
        del: {
          disabled: R.pipe(
            R.prop("isDeletable"),
            R.either(R.equals(0), R.equals("0"))
          ),
          action: deleteFn,
          acl: ACLS.DELETE_PROP,
          style: { color: 'red' }
        },
      },
    };
    return this.renderTable(props);
  }

  /*渲染新表格*/
  renderNewPorps() {
    return (
      <ml-table class="gatewayListTable"
                columns={this.newAppColumns}
                dataSource={this.appList}
                rowKey="id"
                pagination={false}
                canChangeColWidth={true}
                loading={this.subLoading}
      />
    )
  }

  initLiveData(records = this.appProps || []) {
    this.liveData = records.map((item) => ({
      propertyName: item.name,
      propertyValue: "-",
      reportTime: "-",
    }));
  }

  //切换网关应用
  async chooseApp(id) {
    try {
      this.loading = true;
      this.selectAppId = id;
      const { records } = await service.queryGatewayAppProperties(1, id, -1);
      this.appProps = records;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  // 获取新网关app列表
  async getAppList() {
    try {
      this.subLoading = true
      const {items} = await iasp.getIotAppList(undefined, this.sourceData.iotCode, undefined)
      this.appList = items
    } catch (e) {
    }
    this.subLoading = false
  }

  // 查询网关应用设置列表
  async getIotAppSettingList(appCode) {
    try {
      this.appSettingLoading = true
      const {items} = await iassp.getIotAppSettingList(appCode, this.sourceData.iotCode)
      this.appSettingList = items
      this.handleData()
    } catch (e) {
    }
    this.appSettingLoading = false
  }

  handleData() {
    let temp = {}
    let formItems = []
    this.appSettingList && this.appSettingList.forEach(item => {
      item.dataType = Number(item.dataType)
      if (item.dataType > 0 && item.dataType < 21) {
        temp[item.code] = item.currentValue ? item.currentValue : item.defaultValue
        if (item.dataType > 0 && item.dataType < 12) { // 数字输入框
          formItems.push({ type: 'numberInput', label: item.name, key: item.code })
        } else if (item.dataType === 12) { // 时间选择框
          formItems.push({ type: 'timePicker', label: item.name, key: item.code })
        } else if (item.dataType === 20) { // 普通输入框
          formItems.push({ type: 'input', label: item.name, key: item.code })
        }
      }
    })
    this.settingForm = temp
    this.settingFormItems = formItems
  }


  // 查询网关应用属性列表
  async getIotAppPropertyList(appCode) {
    this.appPropertyList = []
    this.appProps = []
    try {
      this.appPropertyLoading = true
      const {items} = await iapsp.getTakeEffectPropertyList(appCode, this.sourceData.iotCode)
      this.appPropertyList = items
      this.appProps = items
      return items
    } catch (e) {
    }
    this.appPropertyLoading = false
  }

  //取消关联
  async cancelRealteFunction() {
    await iotService.deleteWorkStationIot(
      R.prop("iotId", this.sourceData),
      this.workstationId as string
    );
    this.$message.success(this.lang.delete_success);
    this.refresh.associatedIots();
  }

  //获取应用和IOT配置的配置项
  getOptionsFunction(type) {
    const setOptions = this.setState("configOptions");
    const fetchFn = R.prop(type, fetchFnsMap);
    return R.pipe(fetchFn, R.andThen(setOptions));
  }

  //获取打开Dialog的方法
  getOpenConfigModalFunction(type) {
    const getOptions = this.getOptionsFunction(type);
    const changeType = this.setState("type");
    const changeModalType = this.setState("showModal");
    return (...args) => {
      const lastArg = R.last(args);
      const hasRow = R.equals(true, lastArg);

      if (hasRow) {
        const lastSecondIndex = args.length - 2;
        if (type === IotTypes.PropModify) {
          const parseData = (data) => {
            let [ioaddress, props = ""] = (
              data.baseField.ioaddress || ""
            ).split("(");
            data.baseField.ioaddress = ioaddress;
            data.baseField.props = props.replace(")", "");
            return data;
          };
          R.pipe(
            R.path([lastSecondIndex, "name"]),
            R.curryN(2, service.getProperty.bind(service))(this.selectAppId),
            R.andThen(R.pipe(parseData, this.setState("editData")))
          )(args);
        } else {
          R.pipe(R.prop(lastSecondIndex), this.setState("editData"))(args);
        }
        R.pipe(R.dropLast(2), R.apply(getOptions))(args);
      } else {
        this.setState("editData")({});
        getOptions(...args);
      }

      changeType(type);
      changeModalType(true);
    };
  }

  // 查看实时数据
  async openLiveDataModel(record?, type?) {
    let destination = ''
    if (type === 'old') {
      this.initLiveData()
      destination = `${getUserInfo().tenant_id}/${this.sourceData.iotId}/${
        this.selectAppId
        }/#`;
    } else { // 新网关app实时数据
      await this.getIotAppPropertyList(record.code)
      this.initLiveData()
      destination = `${getUserInfo().tenant_id}/${this.sourceData.iotId}/${
        record.id
        }/#`;
    }
    const changeModalType = this.setState("showLiveModal");
    changeModalType(true);

    const global = window as any;

    const ws = (this.ws = new WebSocket(
      // `${global.REALTIME_WEBSOCKET_URL}`
      `${global.REALTIME_WEBSOCKET_URL}/${getToken()}`
    ));
    const onConnect = () => {
      const data = JSON.stringify({
        command: "SUBSCRIBE",
        data: [destination],
        context: String(Date.now()),
      });
      ws.send(data);
    };

    const onError = (err) => {
      // if (responseObject.errorCode === 0) return;
      // this.openLiveDataModel();
    };

    // 接收实时数据并处理
    const onReceive = (message) => {
      var data, command;
      const body = message && message.data;
      if (!body) return;
      try {
        const _body = JSON.parse(body);
        data = _body.data;
        command = _body.command;
        if (command === "AUTHENTICATION" && data.status !== "success") {
          this.$message.error(this.lang.token_overdue);
          return;
        }
        if (command === "CONNECTION" && data.status === "failed") {
          this.$message.error(this.lang.connect_failed);
          return;
        }
      } catch (err) {
        data = null;
        command = null;
      }
      if (!data || command !== "DATA") return;
      const index = this.liveData.findIndex(
        (v) => v.propertyName.toLowerCase() === data.propertyName.toLowerCase()
      );
      if (~index) {
        if (data.propertyValue.includes("timestamp")) {
          try {
            const v = JSON.parse(data.propertyValue);
            const t = dayjs(Number(v.timestamp)).format("YYYY-MM-DD HH:mm:ss");
            if (t !== "Invalid Date") {
              v.timestamp = t;
            } else {
              delete v.timestamp;
            }
            data.propertyValue = JSON.stringify(v);
          } catch (error) {}
        }
        // if (data.propertyName === "报警") {
        //   try {
        //     const v = JSON.parse(data.propertyValue);
        //     data.propertyValue = [
        //       {
        //         propertyName: "报警信息",
        //         propertyValue: v.msg,
        //         reportTime: data.reportTime,
        //       },
        //       {
        //         propertyName: "报警代码",
        //         propertyValue: v.code,
        //         reportTime: data.reportTime,
        //       },
        //       {
        //         propertyName: "报警时间",
        //         propertyValue: v.time,
        //         reportTime: data.reportTime,
        //       },
        //     ];
        //   } catch (error) {}
        // }
        this.$set(this.liveData, index, data);
      }
    };
    ws.addEventListener("error", onError);
    ws.addEventListener("message", onReceive);
    ws.addEventListener("open", onConnect);
  }

  //实时数据
  renderLiveDataModel() {
    const setVisible = this.setState("showLiveModal");
    const concel = (value) => (setVisible(value), this.disConnectWs());

    const dataSource = this.liveData.reduce((total, v) => {
      // if (v.propertyName === "报警" && Array.isArray(v.propertyValue)) {
      //   total.push(...v.propertyValue);
      // } else {
      total.push(v);
      // }
      return total;
    }, []);

    const props = {
      show: this.showLiveModal,
      cancel: concel,
      title: this.lang.live_data,
      columns: this.liveColumns,
      dataSource: dataSource,
      width: 800,
    };
    return this.renderDialogWithTable(props);
  }

  propertyModalVisible = false
  // app属性弹框(app采集项)
  renderAppProperty() {
    const close = ()=> this.propertyModalVisible = false
    const props = {
      show: this.propertyModalVisible,
      cancel: close,
      title: this.lang.view_parameters,
      columns: this.appPropertyColumns,
      dataSource: this.appPropertyList,
      width: 1000
    }
    return this.renderDialogWithTable(props)
  }

  openAppPropertyModal(r) {
    this.propertyModalVisible = true
    this.getIotAppPropertyList(r.code)
  }

  openAppSettingModal(r) {
    this.settingModalVisible = true
    this.appSettingList = []
    this.getIotAppSettingList(r.code)
  }

  disConnectWs() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
    this.initLiveData();
  }

  renderModal() {
    const condFn = (eqType) => R.pipe(R.prop("type"), R.equals(eqType));
    const isEdit = [
      IotTypes.IotConfig,
      IotTypes.PropModify,
      IotTypes.AppConfig,
    ].includes(this.type);
    const conds = [
      [condFn(IotTypes.AppCreate), R.always(0)],
      [
        R.either(condFn(IotTypes.IotConfig), condFn(IotTypes.AppConfig)),
        R.always(1),
      ],
      [
        R.either(condFn(IotTypes.PropCreate), condFn(IotTypes.PropModify)),
        R.always(2),
      ],
    ];

    const schemas = [
      R.prop("appSchema"),
      R.prop("configSchema"),
      R.prop("propSchema"),
    ];

    const renderFns = [
      R.prop("renderDialogWithForm"),
      R.prop("renderDialogWithForm"),
      R.prop("renderDialogWithTabsForm"),
    ];

    const index = R.cond(conds)(this);

    const schema = R.prop(index, schemas)(this);

    const renderFn = R.prop(index, renderFns)(this);
    const setTab = this.setState("activeTab");
    const props: any = {
      title: isEdit ? this.lang.edit : this.lang.create,
      hidden: this.hidden,
      show: this.showModal,
      schema: schema,
      editdata: this.editData,
      tab: this.activeTab,
      tabs: [
        {
          title: this.lang.base_data,
          key: TabTypes.Left,
        },
        {
          title: this.lang.prop,
          key: TabTypes.Right,
        },
      ],
      changeTab: setTab,
      ok: this.getSubmitForm(),
      cancel: this.setState("showModal"),
      ref: this.type + "ref",
      footer: "default",
      confirmLoading: this.confirmLoading,
    };
    return renderFn.bind(this)(props);
  }

  //提交表单
  getSubmitForm() {
    const changeModalType = this.setState("showModal");

    const { iotId } = this.sourceData;
    let fetchFn, effectCb;
    const cacheFetch = (fetchFn = R.prop([this.type], submitFnsMap));
    const cacheCb = (effectCb = () => {
      this.$message.success(this.lang.save_success);
      changeModalType(false);
    });

    if (this.type === IotTypes.IotConfig) {
      // const merge = {
      //   gatewayId: iotId,
      // };
      // fetchFn = (value) => cacheFetch({ ...value, ...merge });
      fetchFn = async (value) => {
        const keys = Object.keys(value);
        const list = keys.map((key) => ({
          name: key,
          value: value[key],
        }));

        return cacheFetch(iotId, list, 1);
      };
    } else if (this.type === IotTypes.AppCreate) {
      const merge = {
        gatewayId: iotId,
      };
      fetchFn = (value) => cacheFetch({ ...value, ...merge });

      effectCb = async () => {
        this.refresh.associatedIots();
        cacheCb();
      };
    } else if (this.type === IotTypes.AppConfig) {
      // const merge = {
      //   gatewayAppId: this.selectAppId,
      // };

      fetchFn = async (value) => {
        const keys = Object.keys(value);
        const list = keys.map((key) => ({
          name: key,
          value: value[key],
        }));

        return cacheFetch(this.selectAppId, list, 2);

        // for (let key of keys) {
        //   await cacheFetch({
        //     name: key,
        //     value: value[key],
        //     ...merge,
        //   });
        // }
      };
      // fetchFn = (value) => cacheFetch({ ...value, ...merge });
    } else {
      const merge = {
        gatewayAppId: this.selectAppId,
        gatewayId: iotId,
        create: this.type === IotTypes.PropCreate,
      };
      fetchFn = (value) => {
        const data = { ...value, ...merge };
        data.baseField.access = 2;
        const props = data.baseField.props;
        if (data.baseField.ioaddress) {
          data.baseField.ioaddress += `(${props || ""})`;
        }
        delete data.baseField.props;
        if (!data.baseField.dataType) data.baseField = null;

        return cacheFetch(data);
      };
      effectCb = () => {
        cacheCb();
        this.chooseApp(this.selectAppId);
      };
    }

    return async (value, setLoading) => {
      // setLoading(true);
      this.confirmLoading = true;
      try {
        await fetchFn(value);
        effectCb();
      } catch (error) {
        this.$message.error((error && error.message) || "服务器错误!");
      } finally {
        this.confirmLoading = false;
        // setLoading(false);
      }
    };
  }

  //获取删除应用和删除采集项的方法
  getDeleteFunction(type) {
    const fetchFn = R.prop(type, deleteFnsMap);
    const effectCb = () => {
      this.$message.success(this.lang.delete_success);
      if (type === "prop") {
        this.chooseApp(this.selectAppId);
      } else {
        this.refresh.associatedIots();
      }
    };

    return R.pipe(fetchFn, R.andThen(effectCb));
  }
}
